import { getConfig } from '@edx/frontend-platform';
import { logError } from '@edx/frontend-platform/logging';

import { apiRequest } from './utils/apiClient';

export const preferencesApi = {
  updateLanguagePreference: async (isAuth: boolean, locale: string, username?: string): Promise<void> => {
    const baseUrl = getConfig().LMS_BASE_URL;

    const url = isAuth
      ? `${baseUrl}/api/user/v1/preferences/${username}`
      : `${baseUrl}/lang_pref/update_language`;

    try {
      await apiRequest({
        url,
        isAuth: true,
        method: 'PATCH',
        data: { 'pref-lang': locale },
        contentType: 'application/merge-patch+json',
      });
    } catch (error) {
      logError('Error updating language preference', error);
    }
  },
};
